<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import SolutoButton from '../../components/SolutoButton.vue';
import RadioButton from '../../components/RadioButton.vue';
import { mapActions, mapGetters } from 'vuex';

// this is Q16 in e-confluence page for call survey. There is no Q17
export default defineComponent({
  name: 'SurveyQ9',
  components: {
    RadioButton,
    Button: SolutoButton
  },
  data () {
    return {
      data: [
        { text: this.$t('10age'), key: '10' },
        { text: this.$t('20age'), key: '20' },
        { text: this.$t('30age'), key: '30' },
        { text: this.$t('40age'), key: '40' },
        { text: this.$t('50age'), key: '50' },
        { text: this.$t('60age'), key: '60' },
        { text: this.$t('70age'), key: '70' }
      ],
      gender: [
        { text: this.$t('male'), key: 'male' },
        { text: this.$t('female'), key: 'female' },
        { text: this.$t('other'), key: 'other' }
      ]
    };
  },
  methods: {
    ...mapActions([
      'changeAge',
      'changeGender'
    ]),
    change (event: number) {
      this.changeAge(event);
    },
    genderChange (event: number) {
      this.changeGender(event);
    },
    nextScreen () {
      if (this.isCallSurvey) {
        // navigate user to new Q18
        router.push({ path: '/survey/question18/' });
      } else {
        router.push({ path: '/survey/end/' });
      }
    },
    goBack () {
      router.go(-1);
    }
  },
  computed: {
    ...mapGetters([
      'getAge',
      'getGender',
      'isCallSurvey'
    ])
  }
});
</script>

<template>
  <div class="mainSurvey">
  <div>
    <p class="with-margin">{{ isCallSurvey ? $t('survey_09_01_call') : $t('survey_09_01') }}</p>
    <p class="with-margin">{{ $t('survey_09_02_call') }}</p>
    <radio-button :text="data" @change="change($event)" :value="getAge"/>
    <p class="with-margin" v-if="!isCallSurvey">{{ $t('survey_09_02') }}</p>
    <radio-button v-if="!isCallSurvey" :text="gender" @change="genderChange($event)" :value="getGender"/>
  </div>
  <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
 </div>
</template>
